import React from "react";
import Events from "../components/pages/Events/Events";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const EventsLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <Events />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default EventsLayout;
